import React from 'react';

import Info from '../../common/info';
import UploadFiles from '../../common/uploadFiles';

export default function ProductSupplier({ onProductSupplierUpload }) {
	return (
		<div id="ProductSupplier" className="tab-pane fade">
			<div className="panel panel-default">
				<div className="panel-body">
					<Info
						heading="Importing Product Supplier"
						message="For further information on importing data, including required field definitions, please"
						link="visit our help pages."
					/>
					<UploadFiles onFileDivClick={() => onProductSupplierUpload()} id="Product Supplier" />
				</div>
			</div>
		</div>
	);
}
